import * as actionConst from './actions';

const initialStage = {
    language: 'th'
}

export default function (state = initialStage, action) {
    switch (action.type) {
        case actionConst.CHANGE_LANGUAGE:
            return {
                ...state,
                language: action.payload
            };
        default:
            return state;
    }
}
